<script setup lang="ts">
import { logoTitle } from '@/utils/PortalConstants';
import imageUrl from '@brand-assets/logo.svg';
</script>

<template>
  <img
    :class="$style.sideBarBigLogoImg"
    data-testid="sideBarBigLogoImg"
    :src="imageUrl"
    :alt="logoTitle"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.sideBarBigLogoImg {
  height: 23px;
}
</style>
